import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'inventory';

export const inventoryI18nManifest: SliceI18nManifest = {
  owner: 'modules/inventory',
  namespaces: [NS],
  resources: {
    cs: { [NS]: cs },
    en: { [NS]: en },
  },
};
